if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.sticky-product-specs, .sticky-add-to-cart__color').forEach((element) => {
        element.hidden = !element.textContent.trim();
      });
      this.button = this.querySelector('button');
      this.main = document.getElementById('MainContent');
      if (!this.main) return;

      this.scheduleUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.onClick = () => {
        if (!this.source || this.button.disabled) return;
        // Reuse validation, engraving, line properties and the existing cart flow.
        this.source.click();
        const error = this.source.closest('product-form')?.querySelector('[role="alert"]:not([hidden])');
        if (error) error.scrollIntoView({ block: 'center', behavior: 'smooth' });
      };
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.scheduleUpdate, { passive: true });
      window.addEventListener('resize', this.scheduleUpdate);
      this.observer = new MutationObserver(this.scheduleUpdate);
      this.observer.observe(this.main, { subtree: true, childList: true, attributes: true, characterData: true });
      this.update();
    }

    update() {
      this.source = this.main.querySelector('product-form form[id^="product-form-"] button[name="add"][type="submit"]');
      if (!this.source) {
        this.hidden = true;
        return;
      }
      const rect = this.source.getBoundingClientRect();
      const label = this.source.querySelector('span')?.textContent.trim() || this.source.textContent.trim();
      this.button.querySelector('span').textContent = label;
      this.button.disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true';
      this.button.setAttribute('aria-busy', String(this.source.classList.contains('loading')));
      if (this.source.hasAttribute('aria-haspopup')) {
        this.button.setAttribute('aria-haspopup', this.source.getAttribute('aria-haspopup'));
      } else {
        this.button.removeAttribute('aria-haspopup');
      }
      // Only show after passing the real CTA; never preempt the product options.
      this.hidden = !this.source.getClientRects().length || rect.bottom > 0;
      const error = this.source.closest('product-form')?.querySelector('[role="alert"]:not([hidden])');
      if (error && error.textContent.trim() && this.lastError !== error.textContent) {
        this.lastError = error.textContent;
        error.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } else if (!error) {
        this.lastError = null;
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.scheduleUpdate);
      window.removeEventListener('resize', this.scheduleUpdate);
      this.button?.removeEventListener('click', this.onClick);
      cancelAnimationFrame(this.frame);
    }
  });

}
